import { PHONE, locationSchema } from "../structured-data-core";

export function getNeptuneStructuredData() {
  const url = "https://restorehair.com/locations/new-jersey/neptune/";
  const description =
    "Find out about your hair transplant options in Neptune with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Neptune", "3600 Route 66", "Neptune", "NJ", PHONE, url, description),
  ];
}
